import React, { useMemo } from "react";

import { FormBuilder, Message } from "shared/components";
import { IFormSchema, IStatus, IAPIError } from "shared/types";
import { Spacer } from "shared/layout";
import { copy } from "shared/assets";

import { makeSchema } from "./formData";
const {
  bandSettings: { deleteBand },
} = copy;

interface DeleteBandFormProps {
  bandName: string;
  hasError?: boolean;
  isSubmitting?: boolean;
  apiError?: IAPIError | null;
  handleDelete: (id?: string) => void;
  handleClose: () => void;
}

export const DeleteBandForm: React.FC<DeleteBandFormProps> = ({
  bandName,
  hasError,
  isSubmitting,
  apiError,
  handleClose,
  handleDelete,
}) => {
  const schema: IFormSchema = useMemo(() => makeSchema("delete", handleClose), [handleClose]);

  return (
    <Spacer size="m">
      <Message
        message={deleteBand.message.replace("%s", bandName)}
        status={IStatus.warning}
        hideBackground
      />
      <FormBuilder
        {...schema}
        onSubmit={handleDelete}
        isSubmitting={isSubmitting}
        apiErrorMessage={hasError}
        apiError={apiError}
      />
    </Spacer>
  );
};
